
import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';

const VideoComponent = lazy(() => import('../../pages/Video/containers/VideoPageContainer'));
const VideoMessageMakerComponent = lazy(() => import('../../pages/Video/containers/VideoMessageMakerContainer'));
const VideoMessageMakerStepComponent = lazy(() => import('../../pages/Video/containers/VideoMessageMakerStepContainer'));
const VideoCouponBoxComponent = lazy(() => import('../../pages/Video/containers/VideoCouponBoxContainer'));
const VideoDetailComponent = lazy(() => import('../../pages/Video/containers/VideoDetailPageContainer'));
const VideoPlayerComponent = lazy(() => import('../../pages/Video/containers/VideoPlayerPageContainer'));
const VideoCompletedComponent = lazy(() => import('../../pages/Video/components/videoCompleted'));

const route = [
  {
    path: ROUTERS.VIDEO_MESSAGE_MAKER,
    title: 'Video Message Maker',
    exact: true,
    public: false,
    component: <VideoMessageMakerComponent />
  },
  {
    path: ROUTERS.VIDEO_MESSAGE_MAKER_STEP,
    title: 'Video Message Maker Step',
    exact: true,
    public: false,
    component: <VideoMessageMakerStepComponent />
  },
  {
    path: ROUTERS.VIDEO_COUPON_BOX,
    title: 'Video coupon box',
    exact: true,
    public: false,
    component: <VideoCouponBoxComponent />
  },
  {
    path: ROUTERS.VIDEO_DETAIL,
    title: 'Video detail',
    exact: true,
    public: false,
    component: <VideoDetailComponent />
  },
  {
    path: ROUTERS.VIDEO_PLAYER,
    title: 'Video player',
    exact: true,
    public: false,
    component: <VideoPlayerComponent />
  },
  {
    path: ROUTERS.VIDEO_COMPLETED,
    title: 'Video completed',
    exact: true,
    public: false,
    component: <VideoCompletedComponent />
  }
];

export default route;